import _pt from "prop-types";
import React from 'react';
export default function Element(_ref) {
  var _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$selfClose = _ref.selfClose,
      selfClose = _ref$selfClose === void 0 ? false : _ref$selfClose,
      Tag = _ref.tagName;
  return selfClose ? React.createElement(Tag, attributes) : React.createElement(Tag, attributes, children);
}
Element.propTypes = {
  attributes: _pt.any,
  children: _pt.node,
  selfClose: _pt.bool,
  tagName: _pt.string.isRequired
};